var MSG_SELECTOR = '.language-message';     // A selector to get the language popup
var COOKIE_NAME = 'languge_selected';     // the cookie name to check
// a list of selectors to watch for so we can drop the cookie
var LANGUAGE_LINKS = 'a.global-language__link';
var VISIBLE_CLASS = 'language-message--visible';
var DISMISS_SELECTOR = '.language-message__close';
var BUTTON_SELECTOR = '.language-message__button';

var SET_NEW_FOCUS = 'screenreaderFocus';

function setCookie(name,value,days) {
    var expires = "";

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function init() {
    if (document.cookie.indexOf(COOKIE_NAME) !== -1) {
        // a language cookie has been set, don't do anything else
        return;
    }

    // catch all the language link clicks and have them drop a cookie
    [].forEach.call(document.querySelectorAll(LANGUAGE_LINKS), function(el) {
        el.onclick = function() {
            setCookie(COOKIE_NAME, 1, 365);
            return true;
        };
    });

    // No language cookie detected, show the msg (if we're not already on the english site)
    if (document.location.pathname.toString().indexOf("/cy/") === 0) {
        // we're on a /cy/ page, don't do anything
        return;
    }

    if (document.location.pathname.toString().indexOf("/en/") === 0) {
        // we're on a /en/ page, don't do anything
        return;
    }

    var banner = document.querySelector(MSG_SELECTOR);

    if (banner) {
        banner.classList.add(VISIBLE_CLASS);

        var dismissLink = document.querySelector(DISMISS_SELECTOR);

        if (dismissLink) {
            dismissLink.onclick = function() {
                document.getElementById(SET_NEW_FOCUS).focus();
                banner.classList.remove(VISIBLE_CLASS);
                setCookie(COOKIE_NAME, 1, 365);
                return false;
            }
        }
    }

    var welshLink = document.querySelector(BUTTON_SELECTOR);

    if (welshLink) {
        welshLink.onclick = function() {
            setCookie(COOKIE_NAME, 1, 365);
            // setTimeout(function () {
            //     document.href = welshLink.getAttribute('href');
            // }, 100);
            // return false;
        }
    }
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/languageMessage.js